import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminFeedback() {
  const [feedback, setFeedback] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    api.get('/feedback/admin')
      .then(r => setFeedback(r.data.data || []))
      .finally(() => setLoading(false));
  }, []);

  const markRead = async (id) => {
    try {
      const r = await api.put(`/feedback/admin/${id}/read`);
      setFeedback(fs => fs.map(f => f._id === id ? r.data.data : f));
    } catch { toast.error('Failed.'); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this feedback?')) return;
    try {
      await api.delete(`/feedback/admin/${id}`);
      setFeedback(fs => fs.filter(f => f._id !== id));
      toast.success('Deleted.');
    } catch { toast.error('Failed to delete.'); }
  };

  const unread = feedback.filter(f => !f.isRead).length;

  const StarRating = ({ n }) => (
    <span className="text-yellow-400 text-sm">{'★'.repeat(n)}{'☆'.repeat(5 - n)}</span>
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-headline font-black text-3xl uppercase tracking-tight">Feedback</h1>
          <p className="font-body text-sm text-secondary mt-1">
            {feedback.length} messages · {unread > 0 && <span className="text-primary-container font-bold">{unread} unread</span>}
          </p>
        </div>
      </div>

      {loading ? (
        <div className="space-y-4">{[...Array(4)].map((_, i) => <div key={i} className="h-28 skeleton" />)}</div>
      ) : feedback.length === 0 ? (
        <div className="text-center py-20">
          <span className="material-symbols-outlined text-[64px] text-outline-variant">feedback</span>
          <p className="font-headline font-bold text-xl uppercase mt-3 text-secondary">No feedback yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {feedback.map(fb => (
            <div key={fb._id} className={`bg-white border ${!fb.isRead ? 'border-primary-container/40 shadow-sm' : 'border-outline-variant/20'} p-5`}>
              <div className="flex items-start gap-4">
                {/* Avatar */}
                <div className={`w-10 h-10 flex items-center justify-center flex-shrink-0 font-headline font-black text-base ${!fb.isRead ? 'bg-primary-container text-white' : 'bg-surface-container text-secondary'}`}>
                  {fb.name?.charAt(0).toUpperCase()}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 flex-wrap mb-1">
                    <span className="font-headline font-bold text-base text-on-surface">{fb.name}</span>
                    {!fb.isRead && <span className="badge badge-orange text-[9px]">New</span>}
                    <StarRating n={fb.rating || 5} />
                    <span className="font-label text-xs text-secondary ml-auto">
                      {new Date(fb.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>

                  <div className="flex gap-4 text-xs text-secondary font-label mb-2">
                    {fb.email  && <span><span className="material-symbols-outlined text-[13px] align-middle">mail</span> {fb.email}</span>}
                    {fb.mobile && <span><span className="material-symbols-outlined text-[13px] align-middle">phone</span> {fb.mobile}</span>}
                  </div>

                  <p className="font-body text-sm text-on-surface leading-relaxed">{fb.message}</p>
                </div>

                {/* Actions */}
                <div className="flex gap-2 flex-shrink-0">
                  {!fb.isRead && (
                    <button onClick={() => markRead(fb._id)}
                      className="p-1.5 text-secondary hover:text-green-600 transition-colors" title="Mark as read">
                      <span className="material-symbols-outlined text-[18px]">mark_email_read</span>
                    </button>
                  )}
                  <button onClick={() => del(fb._id)}
                    className="p-1.5 text-secondary hover:text-error transition-colors" title="Delete">
                    <span className="material-symbols-outlined text-[18px]">delete</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
